import { Injectable } from '@angular/core'

@Injectable()
export class Cache {
  private storage = {}

  put(key: string, value: any) {
    this.storage[key] = value
  }

  get(key: string) {
    return this.storage[key]
  }
}
